export default __webpack_public_path__ + "rss-symbol.png";